import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import logo from "../../assets/images/logo.png";
import { Link, NavLink } from "react-router-dom";
import { useMediaQuery } from 'react-responsive'

import { getToken, getFromStorage, setToken, setToStorage } from "../../services/authService"


Header03.propTypes = {};

function Header03({ clname = "", handleMobile }) {
  const [activeIndex, setActiveIndex] = useState(null);
  const handleDropdown = (index) => {
    setActiveIndex(index);
  };

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 1224px)'
  })
  const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' });


  const [userToken, setUserToken] = useState("");
  const [username, setUsername] = useState("");

  const token = async () => {

    const userToken = getToken();

    if (!userToken) return;

    const username = getFromStorage('username');
    setUsername(username);
    setUserToken(userToken);
  };

  useEffect(() => {
    token();
  }, []);
  return (
    <>
      <header id="header" className="header header-style2">
        <div className="tf-container">
          <div className="row">
            <div className="col-md-12">

              <div className="sticky-area-wrap">
                <div className="ct-left">
                  <div id="logo" className="logo">
                    <Link to="/">
                      <img className="site-logo" src={logo} alt="Image" />
                    </Link>
                  </div>
                </div>


                <div className="header-ct-right">

                  {userToken ? (<div className="header-customize-item login">
                    <Link to="/profile">
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                            stroke="#121212"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                            stroke="#121212"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </Link>
                    <ul className="item-login">
                      <li>
                        <Link to="/profile">{username}</Link>
                      </li>
                    </ul>
                  </div>) : (
                    <div className="header-customize-item login">
                      <Link to="/login">
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                              stroke="#121212"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round" />
                            <path
                              d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                              stroke="#121212"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </Link>
                      <ul className="item-login">
                        <li>
                          <Link to="/login">Login/Register</Link>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
                <div className="nav-filter" onClick={handleMobile}>
                  <div className="nav-mobile">
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <br />
      {/* <br/> */}



      {isTabletOrMobile ? null : <header id="header" className="header header-default">
        <div className="tf-container ct2">
          <div className="row">
            <div className="col-md-12">
              <div className="sticky-area-wrap">
                <div className="header-ct-left">
                  <div className="nav-wrap">
                    <nav id="main-nav" className="main-nav">
                      <ul id="menu-primary-menu" className={`menu ${clname}`}>
                        <li
                          className={`menu-item`}
                        >
                          <Link to="/">Home </Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/news/category/latest">Latest</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/news/category/business">Business</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/news/category/life-in-the-uk">Life in the UK</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/news/category/family-sponsorship">Family Sponsorship</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/news/category/study">Study</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/news/category/work">Work</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/news/category/visit">Visit</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/news/category/citizenship">Citizenship</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/news/category/settling-in-the-uk">Settling in the UK</Link>
                        </li>
                        <li className="menu-item">
                          <Link to="/jobs">Sponsorship Jobs</Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </header>}
    </>
  );
}

export default Header03;
